module.exports = __webpack_public_path__ + "static/media/11NEPAD4.1a85c8b1.jpg";